import materialUI from "material-UI";
import styled from "styled-components";

export const Modal = styled(materialUI.Dialog)`
  .MuiDialog-paper {
    overflow: auto;
    margin: 32px;
  }
  .MuiDialog-paperWidthSm {
    max-width: none;
    max-height: none;
  }
  .MuiDialog-container {
    align-items: center;
    justify-content: center;
  }
`;
